import React, { useState } from "react";

import { Route, Routes, useLocation } from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';

// core components
import Card from "@mui/material/Card";

import MDBox from "../components/MDBox/index.js";

import { Helmet } from 'react-helmet'


export default function BajasPage({ ...props }) {

    const { literal } = props;

    const [loading, setLoading] = React.useState(true);
    const [app, setapp] = React.useState(null);

    const { search } = useLocation();

    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);
        let appinfo = "";

        if (params.has('app'))
            appinfo = params.get('app');

        setapp(appinfo);
        setLoading(false);

        getDataPage(appinfo);

    }, [loading]);


    const getDataPage = (appinfo) => {

        if (appinfo != null && appinfo != "") {
            var jsonData = JSON.stringify(appinfo);

            fetch('api/Data/GetPoliticaPrivacidadOficina', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                //Si se ha recibido un ok
                if (res != null)
                    setapp(res);

            }).catch(error => {
            });
        }
    }

    let rescargando = loading ? <p><CircularProgress color="secondary" /></p> : "";
    
    return (
        <div >
            <Helmet>
                <title>{!loading && app != null && app.nombreOficina != null && app.nombreOficina != "" ? app.nombreOficina : "Account and Associated Data Deletion"}</title>
            </Helmet>
            {rescargando}
            <MDBox py={3} bgColor="white">
                <center><h2>{!loading && app != null && app.nombreOficina != null && app.nombreOficina != "" ? app.nombreOficina + " App Mobile - Eliminacion Cuenta y Datos Asociados " : "App Mobile - Eliminacion Cuenta y Datos Asociados"}</h2></center>
            </MDBox>            
            <iframe src="https://atmovilidad.com/bajas/" width="100%" height="1080" title=""></iframe>
        </div>)
}